<template lang="html">

  <div data="software" class="cv-part">
    <h2 class="title" @click="openedit" :edit="showedit" :empty="!!!info">Software</h2>
    <p v-if="!!info" v-html="info"></p>
    <p v-else @click="openedit">Aún no tienes software añadido, pulsa en editar para añadirlo</p>
    <div class="cover-popup row-center" v-if="showedit">
        <div class="popup">
          <a class="close" @click="showedit = false">✕</a>
          <h2 class="title-pop">Editar software</h2>
          <div class="textarea">
            <label for="editarsoftware">Escribe el software que sabes utilizar</label>
            <textarea v-model="software" id="editarsoftware"></textarea>
          </div>
          <button class="btn" :loading="loading" @click="sendedit">Guardar</button>
        </div>
      </div>
  </div>



</template>

<script lang="js">
  
  import {mapActions} from 'vuex';

  export default {
    name: 'software-cv',
    props :['info'],
    mounted(){
      this.software = this.info; 
      this.software = this.software.replace("&amp;","&")
    },
    data(){
      return{
        showedit: false,
        software : '',
        loading : false
      }
    },
    methods :{
      ...mapActions(['editSoftware','canEditCv']),
      openedit(){
        this.canEditCv().then(r =>{
          (r) ? this.showedit = true : '';
        });
      },
      sendedit(){
        this.loading = true;
        this.software = this.software.replace("&amp;","&")
        this.editSoftware(this.software).then(r =>{
          this.showedit = false;
          this.loading = false;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/software.vue